import $ from 'jquery';
import Masonry from 'masonry-layout';

// Initialize masonry as a jQuery plugin
$.fn.masonry = function(options) {
  return this.each(function() {
    new Masonry(this, options);
  });
};

$(() => {
  $('.gallery').each(function() {
    const $gallery = $(this);
    const masonry = new Masonry(this, {
      itemSelector: '.lg-item',
      percentPosition: true,
      gutter: 20,
      fitWidth: false,
      columnWidth: '.lg-item',
      transitionDuration: '0.27s',
    });
    
    // Store masonry instance on the element for later use
    $gallery.data('masonry', masonry);
  });
});